<template>
  <div class="myVouchers">
    <a-tabs defaultActiveKey="1" @change="callback">
      <a-tab-pane :tab="$tc('lang.UserCenter.Available')" key="1">
        <may-use></may-use>
      </a-tab-pane>
      <a-tab-pane :tab="$tc('lang.UserCenter.Used')" key="2">
        <used></used>
      </a-tab-pane>
      <a-tab-pane :tab="$tc('lang.UserCenter.Expired')" key="3">
        <expired></expired>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
import mayUse from './myVouchersComponents/mayUse';
import used from './myVouchersComponents/used';
import expired from './myVouchersComponents/expired';
export default {
  methods: {
    callback(key) {
      console.log(key);
    },
  },
  components: {
    mayUse,
    used,
    expired,
  },
};
</script>
<style lang="less">
.myVouchers {
  margin-top: 3%;
  text-align: left;
}
</style>
